import axios from 'axios';

export const accountCenterApi = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_ACCOUNT_CENTER_URL}${process.env.NEXT_PUBLIC_API_PREFIX}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
